export const studyingForms = [
  {
    text: 'Бюджет',
    short: 'Б',
    value: 'budget'
  },
  {
    text: 'Контракт',
    short: 'К',
    value: 'contract'
  },
  {
    text: 'Целевое',
    short: 'Ц',
    value: 'target'
  }
]
